
  <app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

  <div class="container">
      <header class="main-header">
        <div class="navbar-header" [class.example-is-mobile]="mobileQuery.matches">
          <mat-toolbar color="primary">
          
            <img class="logo-mini navbar-brand" style="width:32px;margin-bottom:13px;margin-left:12px;"
              src="assets/img/EY_Logo.png" alt="" />
            <h1 class="example-app-name"> <b class="Title">IN TAX GTC </b> </h1>
            <button mat-button class="VIEWS"  (click)="Home()">Home</button>
            <button *ngIf="_global.IsAdmin || _global.IsTQApprover  || _global.IsTQLeader || _global.IsEngTeam"
            #menuTrigger1="matMenuTrigger"
            mat-button
           
              [matMenuTriggerFor]="RequisitionViews" class="VIEWS">Requisition</button>
  
  
            <mat-menu  #RequisitionViews="matMenu"  >
              <button mat-menu-item *ngIf="_global.IsAdmin || _global.IsEngTeam" mat-menu-item
                (click)="CreateGTCRequest()">
                Create GTC Request</button>
                <button mat-menu-item *ngIf="_global.IsAdmin || _global.IsTQApprover  || _global.IsTQLeader " mat-menu-item
                (click)="AllRequisition()">
                All Requisition View </button>
                <button mat-menu-item *ngIf="_global.IsAdmin || _global.IsEngTeam" mat-menu-item
                (click)="MyRequisition()">
                My Requisition</button>
                <button mat-menu-item *ngIf="_global.IsAdmin  || _global.IsTQApprover  || _global.IsTQLeader" mat-menu-item
                (click)="ApprovedRequistion()">
                All Approved Requisition</button>
            </mat-menu>
  
            <button *ngIf="_global.IsAdmin || _global.IsTQApprover  || _global.IsTQLeader"
             mat-button
         
        
  
            [matMenuTriggerFor]="ApprovalViews" class="VIEWS">Pending for Approval</button>
  
            <mat-menu #ApprovalViews="matMenu">
              <button  mat-menu-item  *ngIf="_global.IsAdmin || _global.IsTQApprover" mat-menu-item
                (click)="TQApproval()">TQ Approval 
              </button>
              <button  mat-menu-item  *ngIf="_global.IsAdmin || _global.IsTQLeader" mat-menu-item
                (click)="SpecialApproval()">TQL Approval 
              </button>
            </mat-menu>
            <button *ngIf="_global.IsAdmin"
            #menuTrigger3="matMenuTrigger"
      
  
            mat-button [matMenuTriggerFor]="Role"
              class="VIEWS">Role</button>
  
            <mat-menu #Role="matMenu">
              <button  *ngIf="_global.IsAdmin" mat-menu-item
                (click)="AssignRoles()">Assign Roles</button>
            </mat-menu>
            <button *ngIf="_global.IsAdmin || _global.IsTQApprover  || _global.IsTQLeader || _global.IsEngTeam"
            #menuTrigger4="matMenuTrigger"
  
  
            mat-button [matMenuTriggerFor]="ReportView"
            class="VIEWS">Reports</button>
          <mat-menu #ReportView="matMenu" yPosition="below">
            <button  mat-menu-item  *ngIf="_global.IsAdmin || _global.IsTQApprover  || _global.IsTQLeader || _global.IsEngTeam" mat-menu-item
              (click)="GTCReport()">GTC Report</button>
          </mat-menu>

          
           <button *ngIf="_global.IsAdmin || _global.IsTQApprover || _global.IsTQLeader || _global.IsEngTeam"
           type="button"
           class="VIEWS"
           mat-button
           [disabled]="isToolGuideDownloading"
           (click)="downloadPdf()">
          GTC Tool Guide
         </button>
       

          
            <div class="LogOut">
    
             <div class="navbar-custom-menu hidden-xs">
              
                      <ul class="nav navbar-nav">
              
                       <li class="dropdown user user-menu">
              
                        <div  class="dropdown-toggle" data-bs-toggle="dropdown">
              
                         <img src="assets/img/defaultImage.jpg" class="user-image rounded-circle" loading="lazy"
              
                          style="height: 30px;" />
              
                         <span class="username">{{ UserName | uppercase }}</span>
              
                        </div>
              
                        <ul class="dropdown-menu">
              
                         <li class="user-header">
              
                          <div class="drop-img">
              
                           <img src="assets/img/defaultImage.jpg" class="user-image rounded-circle" alt="User Image" />
              
                          </div>
              
                         </li>
              
                        <span>
                          <p class="userloginname">{{ UserName | uppercase }} <span>  ({{_global.CurrentRole}})</span></p>
                          
                        </span> 
                        
                         <li class="user-footer">
              
                          <tr>
              
                           <td>
              
                            <button mat-stroked-button href="javascript:createBookmark()" class="VIEWS"
              
                             title="bookmark this page" type="button">
              
                             Add to Favorite
              
                            </button>
              
                           </td>
              
                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              
                           <td>
              
                            <button mat-stroked-button (click)="logoutUser()" class="VIEWS"
              
                             title="Logout this page">
              
                             Logout
              
                            </button>
              
                           </td>
              
                          </tr>
              
                         </li>
              
                        </ul>
              
                       </li>
              
                      </ul>
              
                     </div>
              
                    </div>
          </mat-toolbar>
          <router-outlet></router-outlet>
        </div>
      </header>
      <div class="content-wrapper" style="margin:5px" *ngIf="isDashboardVisiblity">
        <!-- Main content -->
        <section class="content">
            <!-- Default box -->
            <div class="box">
                <img src="../../../../assets/img/dashboard.JPG" style="width: 100%; height: 600px;" alt="dashboard image" />
            </div>
        </section>
    </div>
      
      <!-- <pre >
        <code [innerHTML]="highlightedText"></code>
      </pre> -->
      <footer>
        <div class="row fixed-bottom" style="text-align: center; background-color: black; color: white;">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div>
                    <footer>&copy; {{ Year }}- Ernst & Young LLP All Right
                        reserved. For Internal use only.</footer>
                </div>
            </div>
        </div>
    </footer>
    </div>


  